import { render, staticRenderFns } from "./unitCreditList.vue?vue&type=template&id=66048014&scoped=true"
import script from "./unitCreditList.vue?vue&type=script&lang=js"
export * from "./unitCreditList.vue?vue&type=script&lang=js"
import style0 from "./unitCreditList.vue?vue&type=style&index=0&id=66048014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66048014",
  null
  
)

export default component.exports